import { useMemo } from 'react';

import { useBizyNavigationOverride } from '../bizy-navigation-context';
import { useBizyExternalOpenStore } from '../store/use-bizy-external-open-store';
import { useBizyPageContextStore } from '../store/use-bizy-page-context-store';
import { useBizyGlobalChat } from './use-bizy-global-chat';

export function useBizySidePanelChat() {
	const context = useBizyPageContextStore((state) => state.context);
	const pendingRequest = useBizyExternalOpenStore((state) => state.pendingRequest);
	const navigationOverride = useBizyNavigationOverride();

	const extraContext = useMemo(() => {
		const baseContext: Record<string, string> = {
			bizy_page_name: context.pageName,
			bizy_page_type: context.pageType,
			...(context.pageData || {}),
		};

		// When the panel was opened via bizy:open (e.g. "Request a feature" button),
		// attach the entry point source to the API context. The backend saves source
		// on ChatHistory and the system prompt uses it to tailor behavior (e.g.
		// feature request conversations collect feedback instead of troubleshooting).
		// Only present for the first message — cleared after auto-send — but
		// conversation history carries the intent forward.
		// The page context is already covered by bizy_page_name/bizy_page_type above.
		if (pendingRequest) {
			baseContext.source = pendingRequest.source;
			baseContext.source_page_path = pendingRequest.pagePath;
		}

		return baseContext;
	}, [context.pageData, context.pageName, context.pageType, pendingRequest]);

	return useBizyGlobalChat({
		extraContext,
		navigateFn: navigationOverride ?? undefined,
	});
}
